var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"el",staticClass:"d-flex flex-column justify-space-around align-center",class:{
    flexColumn: _vm.isVertical,
    wFull: !_vm.isVertical,
  },style:({
    ..._vm.margin,
  })},_vm._l((_vm.dots || _vm.nOfDots),function(i){return _c('div',{key:`t-${i}`,staticClass:"dot",class:{ top: _vm.top, bottom: _vm.bottom, left: _vm.left, right: _vm.right, vertical: _vm.vertical },style:({
      backgroundColor: _vm.bgColor,
      width: `${_vm.size}px`,
      height: `${_vm.size}px`,
    })})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }